<template>
  <div class="userNotification">
    <userNotificationList ref="list"></userNotificationList>
    <router-view @list-reload="listReload" />
  </div>
</template>

<script>
import userNotificationList from './userNotificationList.vue'

export default {
  components: {
    userNotificationList
  },
  methods: {
    async listReload() {
      await this.$refs.list.reload()
    }
  }
}
</script>
<style scoped>
.userNotification {
  height: 100%;
  overflow-wrap: anywhere;
}
</style>



// WEBPACK FOOTER //
// src/components/userNotification/userNotification.vue